import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

// Renders children only while raffle sales are switched on in the CMS.
export const RaffleGate = ({ children }) => {
  const [on, setOn] = useState(null);
  useEffect(() => {
    api.get("/raffle/config")
      .then(r => setOn(r.data?.settings?.sales_enabled !== false))
      .catch(() => setOn(false));
  }, []);
  if (on === null) return null;
  return on ? children : <Navigate to="/raffle" replace />;
};
